import React from 'react';



import { Track, Point, TrackValue, TrackValuePlus, PointSection } from "./styles";

export const RentalPlanSelectorTrack = ({
  isShortVersion,
  points,
  handlePointClick,
  handlePointHover,
  handlePointKeyDown,
  pointAccentColors,
  allPointsHaveAccentColor,
  isDisabled,
  hasPlusLabel,
  currentPointIndex }) =>
{
  return /*#__PURE__*/(
    React.createElement(Track, { isShortVersion: isShortVersion, role: "radiogroup" },
    points?.map((point, index) => /*#__PURE__*/
    React.createElement(PointSection, {
      key: point.value,
      onClick: () => handlePointClick(point),
      onMouseOver: () => handlePointHover(point),
      onFocus: () => handlePointHover(point),
      onKeyDown: (e) => handlePointKeyDown(e, index),
      $isShortVersion: isShortVersion,
      role: "radio",
      "aria-checked": index === currentPointIndex,
      "aria-label": `${point.value}${hasPlusLabel ? '+' : ''} ${point.label}`,
      tabIndex: index === currentPointIndex ? 0 : -1 }, /*#__PURE__*/

    React.createElement(Point, {
      hasAccentColors:
      Boolean(point?.hasAccentColors) && !allPointsHaveAccentColor,

      backgroundColor: pointAccentColors?.backgroundColor ?? '',
      isShortVersion: isShortVersion,
      isDisabled: isDisabled }, /*#__PURE__*/

    React.createElement(TrackValue, {
      hasAccentColors:
      Boolean(point?.hasAccentColors) && !allPointsHaveAccentColor,

      textColor: pointAccentColors?.textColor ?? '',
      isDisabled: isDisabled },

    point.value,
    hasPlusLabel && /*#__PURE__*/React.createElement(TrackValuePlus, null, "+")))))));






};